import React, {createContext, useState} from 'react';
import ReadyProductStockTransactionService from "../../services/ReadyProductStockTransactionService";
import {getErrorMessage} from "../../helpers/Utils";
import {Toast} from "../../components/common/Toast";

export const ReadyProductStockTransactionContext = createContext("ReadyProductStockTransactionContext");

const ReadyProductStockTransactionContextProvider = ({children}) => {


    const [loading, setLoading] = useState(false);
    const [totalElements, setTotalElements] = useState(0);
    const [stockTransactionList, setStockTransactionList] = useState([]);

    const [stocksLoading, setStocksLoading] = useState(false);
    const [stocksTotalElements, setStocksTotalElements] = useState(0);
    const [stockList, setStockList] = useState([]);

    const getAllStockTransaction = async params => {
        try {

            setLoading(true);

            const res = await ReadyProductStockTransactionService.getAllStockTransaction(params);
            setStockTransactionList(res.data.content);
            setTotalElements(res.data.totalElements);

            setLoading(false);

        } catch (error) {

            setLoading(false);

            const message = getErrorMessage(error);
            Toast("error", "Error", message);

        }
    }

    const getAllStock = async params => {
        try {

            setStocksLoading(true);

            const res = await ReadyProductStockTransactionService.getStockTransactionsByIngredientId(params);
            setStockList(res.data.content);
            setStocksTotalElements(res.data.totalElements);

            setStocksLoading(false);

        } catch (error) {

            setStocksLoading(false);

            const message = getErrorMessage(error);
            Toast("error", "Error", message);

        }
    }

    return (
        <ReadyProductStockTransactionContext.Provider
            value={{
                loading,
                totalElements,
                stockTransactionList,
                stocksLoading,
                stocksTotalElements,
                stockList,
                setStockList,
                getAllStockTransaction,
                getAllStock,
            }}
        >
            {children}
        </ReadyProductStockTransactionContext.Provider>
    );
}

export default ReadyProductStockTransactionContextProvider;
